// extracted by mini-css-extract-plugin
export default {"label":"style_label__yo1bK","button":"style_button__4zJ56"};